import { ApolloClient, NormalizedCacheObject, useLazyQuery, useMutation } from '@apollo/client';
import {
  AuthData,
  AuthVars,
  UpdatePasswordData,
  UpdatePasswordVars
} from '../../membership/gql-types';

import ApolloClientService from '../services/ApolloClientService';
import Config from '../config';
import MembershipGraphQL from '../../membership/gql';
import { useState } from 'react';

let membershipApolloClient: ApolloClient<NormalizedCacheObject> = null;

function usePasswordUpdates() {
  const [_authData, _setAuthData] = useState<AuthData>();

  if (!membershipApolloClient) {
    membershipApolloClient = ApolloClientService.create(Config.MEMBERSHIP_GQL);
  }

  const [auth, {
    called: authCalled,
    loading: authLoading,
    error: authError,
    // data: authData
  }]
  = useLazyQuery<AuthData, AuthVars>(
    MembershipGraphQL.Query.AUTH,
    {
      client: membershipApolloClient,
      onCompleted: (data) => {
        _setAuthData(data);
      },
      fetchPolicy: 'network-only'
    }
  );

  const [updatePassword, {
    called: updatePasswordCalled,
    loading: updatePasswordLoading,
    error: updatePasswordError,
    data: updatePasswordData
  }]
  = useMutation<UpdatePasswordData, UpdatePasswordVars>(
    MembershipGraphQL.Mutation.UPDATE_PASSWORD,
    {
      client: membershipApolloClient,
    }
  );

  function resetAuth() {
    _setAuthData(undefined);
  }

  return {
    auth: (tenant: string, username: string, password: string) => auth({ variables: { tenant, username, password }}),
    resetAuth,
    updatePassword: (
      tenant: string,
      username: string,
      password: string
    ) => updatePassword({
      variables: {
        tenant,
        username,
        password
      }
    }),
    authCalled,
    authLoading,
    authError,
    authData: _authData,
    updatePasswordCalled,
    updatePasswordLoading,
    updatePasswordError,
    updatePasswordData
  };
}

export default usePasswordUpdates;


